export default __webpack_public_path__ + "static/media/charles.b3a7abf3.webp";